import { render, staticRenderFns } from "./QuotationModelList.vue?vue&type=template&id=2863ddca&scoped=true"
import script from "./QuotationModelList.vue?vue&type=script&lang=js"
export * from "./QuotationModelList.vue?vue&type=script&lang=js"
import style0 from "./QuotationModelList.vue?vue&type=style&index=0&id=2863ddca&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2863ddca",
  null
  
)

export default component.exports